import { css } from 'styled-components';

const buttons = css`
  .me-button {
    color: var(--grey800);
    border: 0;
    height: 32px;
    text-align: center;
    line-height: 32px;
    padding: 0 16px;
    border-radius: 4px;
    font-weight: bold;
    outline: none;
    background: transparent;
    &:hover:not([disabled]) {
      cursor: pointer;
      color: var(--grey900);
    }
    &[disabled] {
      opacity: 0.5;
    }
  }

  .me-button__grey-ghost {
    border: 1px solid var(--grey300);
    &:hover:not([disabled]) {
      background-color: var(--grey100);
    }
    &__selected {
      &,
      &:hover {
        background-color: var(--primary100);
        border-color: var(--primary300);
      }
    }
  }

  .me-button__primary-solid-dark {
    border: none;
    background-color: var(--primary500);
    color: white;
    &:hover:not([disabled]) {
      background-color: var(--primary700);
      color: white;
    }
  }
`;

export default buttons;
